export class News {
  public id : number;
  public title : string;
  public description : string;
  public pictureUrl : string;

  public displayedAtMainPage : boolean;
  public special : boolean;

}
